import { AppMode, UserSession, SessionInfo, DeploymentMode } from './common/managers/Types';
import { ErrorBoundary, LicensingContext, Logger } from '@viamap/viamap2-common';

import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-data-grid/lib/styles.css';
import FileImporter from './components/FileImporter';
import { SessionContext } from '@viamap/viamap2-common';
import { SessionActionType } from '@viamap/viamap2-common';
import RightPane from './components/RightPane';
import { ProjectManager } from './components/Projects';

import { GenericTransactionManager, MapitStateActions, MapitStateContext, MapitStateReducer, initialMapitState, transactionalMapitStateReducer } from './states/MapitState';
import { RightPaneContext, useSetupRightPane } from './states/RightPaneState';
import MapScreen from './components/MapScreen';
import { useState, useContext, useReducer, useEffect, Fragment } from "react";
import { WindowManager } from './WindowManager/WindowManager';
import { WebsocketManager } from './components/MitWebsocketManager';
import { ApplicationStateContext, Feature } from './states/ApplicationState';
import { FileDropInformation } from './components/FileDropInformation';
import { InsideQueryHandler } from './components/InsideQueryHandler';
import { StatTracker, useStatTracker } from './common/managers/StatTracker';
import { ActionTracker } from './common/managers/ActionTracker';

export function Application() {
  const [sessionInfo, setSessionInfo] = useState<SessionInfo>();
  const { state: newUserSession, dispatch: sessionDispatch } = useContext(SessionContext);
  const { hasAccessToFeature } = useContext(ApplicationStateContext);
  const { state: licensingState } = useContext(LicensingContext);
  const [restoring, setRestoring] = useState(false)
  useStatTracker("App", "Mapit")

  const [mapitState, mapitStateDispatch] = useReducer(MapitStateReducer, initialMapitState());

  const modusState = useSetupRightPane()

  useEffect(() => {
    if (restoring) {
      setTimeout(() => setRestoring(false), 100)
    }
  }, [restoring])

  useEffect(() => {
    const getTitle = () => {
      let hasLicense = licensingState.currentlicense;
      if (!hasLicense) {
        return "Unlicensed"
      }
      let variant = licensingState.currentlicense?.productVariant;
      if (variant?.includes("Explorer")) {
        return 'Estate Explorer'
      }
      return `${licensingState.currentlicense?.product} ${licensingState.currentlicense?.productVariant}`
    }
    document.title = getTitle()
  }, [licensingState.currentlicense])

  useEffect(() => {
    mapitState.map?.once?.("webglcontextlost", () => {
      console.info('%c Map Content Lost ', 'color: #bada55')
      setRestoring(true)
    })
  }, [mapitState.map])

  useEffect(() => {

    let us: UserSession = {
      id: newUserSession.userName || "",
      userName: newUserSession.userName,
      email: newUserSession.userRef,
      jwtToken: newUserSession.userSession?.getAccessToken().getJwtToken() || "",
      name: newUserSession.userName,
      userRoles: [], // [...(newUserSession.userRoles ? newUserSession.userRoles : []),...license.valid.map((a) => a.productVariant)],
      deploymentMode: DeploymentMode.Testing,
      isAnonymousSession: false,
    }

    setSessionInfo({
      userSession: us,
      mapReferenceData: undefined,
      appMode: AppMode.Normal,
      commandList: undefined
    })
    console.log(newUserSession);
    StatTracker.attachUserInfo(newUserSession?.userSession?.getIdToken?.()?.payload?.sub, newUserSession.userRef, newUserSession.customerRef);
    ActionTracker.attachUserInfo(newUserSession?.userSession?.getIdToken?.()?.payload?.sub, newUserSession.userRef, newUserSession.customerRef, newUserSession);
    Logger.logAction("Application", "User session started", "Map Loaded")
  }, [newUserSession, licensingState])



  function LogOut() {
    sessionDispatch({
      type: SessionActionType.Logoff,
      payload: {
        userName: sessionInfo?.userSession?.userName ?? newUserSession.userName
      }
    })
  }

  if (sessionInfo !== undefined)
    return (
      <Fragment key={hasAccessToFeature(Feature.ThemeNewSec) ? "Theme-Newsec" : "Theme-Default"}>
        {/* /\ update map style */}
        <ErrorBoundary>
          <WindowManager>
            <MapitStateContext.Provider
              value={{
                state: mapitState,
                dispatch: GenericTransactionManager.dispatchMiddleware<MapitStateActions>(mapitStateDispatch, transactionalMapitStateReducer)
              }}
            >
              <WebsocketManager />
              <RightPaneContext.Provider value={modusState} >
                <ProjectManager >
                  {/* <button onClick={(e) => setRestoring(true)} style={{position:"absolute", zIndex:"10001"}}>Test</button> */}
                  {/* <MapitV4Banner/> */}
                  <FileImporter>
                    <InsideQueryHandler />
                    <FileDropInformation />
                    <RightPane>

                      {restoring ?
                        <></>
                        :
                        <MapScreen
                          callbackToLogout={() => { LogOut() }}
                          showTrialSignupDialog={false}
                          callBackOnTrialSignup={(name, company, phoneNo, termsApproved) => console.info(name, company, phoneNo, termsApproved)}
                          callBackMap={() => { }}
                        />
                      }
                    </RightPane>
                  </FileImporter>
                </ProjectManager>
              </RightPaneContext.Provider>
            </MapitStateContext.Provider>
          </WindowManager>
        </ErrorBoundary>
      </Fragment>
    );

  return (null)
}



